import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "245",
  "slug": "how-to-read-satellite-image-beginners-guide",
  "title": "How to Read a Satellite Image: A First Pass",
  "excerpt": "Start with scale and orientation, then separate observations from guesses.",
  "date": "2026-03-17",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1446776858070-70c3d5ed6758?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Before trying to name a place, establish what the image shows. Check its scale, orientation, date, and source if they are available. A dark shape could be a small pond or a large lake; colour alone cannot tell you which."
    },
    {
      "type": "heading",
      "text": "Start with the larger features"
    },
    {
      "type": "paragraph",
      "text": "Find the coast or major water bodies, if any. Follow ridges and valleys, then look for settlements, roads, and field boundaries. Describe their relationships: a town at a river junction, fields on a flat valley floor, or a road following the coast."
    },
    {
      "type": "paragraph",
      "text": "Write observations that someone else could check. “A river bends around the town” is more useful than “this feels European.” Keep the place name as a separate hypothesis."
    },
    {
      "type": "heading",
      "text": "Use a second clue"
    },
    {
      "type": "paragraph",
      "text": "If rectangular fields suggest one region, ask where else they occur. Add relief, drainage, or coastal orientation to the comparison. A small inland crop can come from an island, and a dry-looking field can be seasonal rather than desert."
    },
    {
      "type": "heading",
      "text": "Check after the reveal"
    },
    {
      "type": "paragraph",
      "text": "Find the actual location on a labelled map. Return to the image and identify which observation helped, which misled you, and what was outside the frame. If the image did not contain enough evidence, record that uncertainty instead of inventing a rule from one round."
    },
    {
      "type": "paragraph",
      "text": "For the next attempt, choose one feature to follow more carefully. You do not need to memorise every landscape at once."
    }
  ],
  "relatedSlugs": [
    "reading-landscapes-from-space-land-use",
    "how-to-get-better-at-geography-games"
  ]
};
